export const locale = {
    lang: 'es',
    data: {
        USUARIOS: {
            ADD: {
                TITLE: 'NUEVO USUARIO'
            }
        }
    }
};
